import { render, staticRenderFns } from "./userFlowChart.vue?vue&type=template&id=0b7b4563&scoped=true"
import script from "./userFlowChart.vue?vue&type=script&lang=js"
export * from "./userFlowChart.vue?vue&type=script&lang=js"
import style0 from "./userFlowChart.vue?vue&type=style&index=0&id=0b7b4563&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b4563",
  null
  
)

export default component.exports